import React from 'react'
import Typography from '../../../components/Basics/Typography'
import {
  Container,
} from './About.styles'

const About = () => {
  return (
    <Container>
      <Typography variant="h1">About</Typography>
      <Typography lineHeight="1.7" margin="0.75rem 0 0">
        Senior Software Engineer with 14 years building scalable enterprise
        applications, distributed systems, and cloud-based solutions. Specialized
        in Java, Spring Boot, React, .NET, and AWS, with a track record on
        high-availability government and SaaS platforms. Based in Dublin and
        available for freelance and independent engagements — backend, full-stack,
        and product-focused engineering.
      </Typography>
    </Container>
  )
}

export default About
